import { render } from "./Keypad.vue?vue&type=template&id=c0df5946&scoped=true"
import script from "./Keypad.vue?vue&type=script&lang=js"
export * from "./Keypad.vue?vue&type=script&lang=js"

import "./Keypad.vue?vue&type=style&index=0&id=c0df5946&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0df5946"]])

export default __exports__